import React from 'react';
import FormSection from '../../../FormElements/FormSection';
import Label from '../../../FormElements/Label';
import TextInput from '../../../FormElements/TextInput';
import DropdownList from '../../../FormElements/DropdownList';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PrimaryButton from '../../../Buttons/PrimaryButton';
import SecondaryButton from '../../../Buttons/SecondaryButton';

export default class OrganizationFormSection extends React.Component {
	constructor(props) {
		super(props);

		var todaysDate = new Date();
		if (todaysDate.getMonth() == 11) {
			var startDate = new Date(todaysDate.getFullYear() + 1, 0, 1);
		} else {
			var startDate = new Date(
				todaysDate.getFullYear(),
				todaysDate.getMonth() + 1,
				1
			);
		}

		this.state = {
			legalOrganizationType: '',
			businessStartDate: startDate,
			organizationStartDate: startDate,
			organizationState: 'HI',
			accountingPeriodType: 'Calendar Year',
			accountingMethod: 'Cash',
			naicsBusinessActivity: '72119 - Other Traveler Accommodation',
			businessMainPhonePumber: 'Acct #',
			businessAlternatePhoneNumber: '',
			businessEmail: 'Acct Email'
		};

		this.onChange = this.onChange.bind(this);
		this.onChangeBusinessStartDate = this.onChangeBusinessStartDate.bind(this);
		this.onChangeOrganizationStartDate = this.onChangeOrganizationStartDate.bind(
			this
		);
	}

	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		console.log('OrganizationFormSection', this.props, this.state);
		return (
			<div className="w-full py-4">
				<FormSection>
					<DropdownList
						label="Organization Type *"
						displayLabel={true}
						onChange={this.onChange}
						id="legalOrganizationType"
						name="legalOrganizationType"
						value={this.state.legalOrganizationType}
						data={[
							{
								id: 0,
								name: ''
							},
							{
								id: 1,
								name: 'Sole Proprietorship'
							},
							{
								id: 2,
								name: 'Single-Member LLC'
							},
							{
								id: 3,
								name: 'LLC'
							},
							{
								id: 4,
								name: 'Corporation'
							},
							{
								id: 5,
								name: 'S Corporation'
							},
							{
								id: 6,
								name: 'Limited Partnership'
							},
							{
								id: 7,
								name: 'General Partnership'
							}
						]}
					/>
					<Label htmlFor="businessStartDate">Businuess Start Date</Label>
					<div className="mb-6">
						<DatePicker
							className="block border mt-1 px-3 py-2 h-10 rounded-md w-100"
							selected={this.state.businessStartDate}
							onChange={this.onChangeBusinessStartDate}
							name="startDate"
							dateFormat="MM/dd/yyyy"
							disabled
						/>
					</div>
					<Label htmlFor="organizationStartDate">Organization Start Date</Label>
					<div className="mb-6">
						<DatePicker
							className="block border mt-1 px-3 py-2 h-10 rounded-md w-100"
							selected={this.state.organizationStartDate}
							onChange={this.organizationStartDate}
							name="startDate"
							dateFormat="MM/dd/yyyy"
							disabled
						/>
					</div>
					<Label htmlFor="businessMainPhonePumber">
						Business Main Phone Number *
					</Label>
					<TextInput
						id="businessMainPhonePumber"
						name="businessMainPhonePumber"
						value={this.state.businessMainPhonePumber}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessAlternatePhoneNumber">
						Business Alternate Phone Number
					</Label>
					<TextInput
						id="businessAlternatePhoneNumber"
						name="businessAlternatePhoneNumber"
						value={this.state.businessAlternatePhoneNumber}
						onChange={this.onChange}
					/>
					<Label htmlFor="businessEmail">Business Email</Label>
					<TextInput
						id="businessEmail"
						name="businessEmail"
						value={this.state.businessEmail}
						onChange={this.onChange}
					/>
				</FormSection>
				<div className="grid">
					<div className="lg:justify-self-end mb-4 lg:mb-0">
						<SecondaryButton
							label="Continue"
							onClick={() => {
								this.props.continueLocation(
									this.state.legalOrganizationType,
									this.state.businessStartDate,
									this.state.organizationStartDate,
									this.state.organizationState,
									this.state.accountingPeriodType,
									this.state.accountingMethod,
									this.state.naicsBusinessActivity,
									this.state.businessMainPhonePumber,
									this.state.businessAlternatePhoneNumber,
									this.state.businessEmail
								);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onChangeBusinessStartDate(date) {
		this.setState({
			onChangeBusinessStartDate: date
		});
	}

	onChangeOrganizationStartDate(date) {
		this.setState({
			organizationStartDate: date
		});
	}
}
